module.exports = __webpack_public_path__ + "clover.d61b6beae2985174b34e9feb442f7c08.webp";